<template>
  <div style="text-align: center;">
    <div v-if="!hasError">
      <van-col :span="24" style="text-align: center;">
        订单信息
      </van-col>
      <base-input v-model="currSellOrder.order_date" label="订单时间" readonly />
      <base-input v-model="currSellOrder.code" label="订单号" readonly />
      <base-input-number v-model="currSellOrder.receivable_amount" label="订单金额" readonly />
      <base-input v-model="currSellOrder.orderer" label="订货人" readonly />
      <base-input v-model="currSellOrder.orderer_phone" label="订货人电话" readonly />
      <base-input v-model="currSellOrder.delivery_time" label="送货时间" readonly />
      <base-input v-model="currSellOrder.receiver" label="收货人" readonly />
      <base-input v-model="currSellOrder.receiver_phone" label="收货人电话" readonly />
      <base-textarea v-model="currSellOrder.receiver_addr" label="收货人地址" readonly />
      <van-col v-if="hasIssued" span="17" style="font-size: 15px; font-weight: bold; color: #13ce66;">
        您当前查看的订单已经送出！
      </van-col>
      <van-col v-else span="17" style="font-size: 15px; font-weight: bold; color: #ff4949;">
        请您标记订单送出
      </van-col>
      <van-col :span="7" style="text-align: center;">
        <base-button :disabled="!canIssued" @click="openLocation">{{ hasIssued ? '查看上报位置' : '查看当前位置' }}</base-button>
      </van-col>
      <van-col :span="24">
        <br>
        <base-button size="large" :disabled="!canIssued" @click="handleIssued">订单送出</base-button>
      </van-col>
    </div>
    <div v-else>
      <span style="font-size: 16px; font-weight: bold; color: #ff4949;">{{ errorMsg }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { issuedSellOrder, getSellOrderList } from '@/api/sell/order'
import { wxJsConfig } from '@/api/commons'
export default {
  name: 'DeliveryIssued',
  data() {
    return {
      form: {
        main_id: 0,
        start_longitude: 0,
        start_latitude: 0
      },
      hasIssued: false,
      hasError: false,
      canIssued: false,
      errorMsg: '',
      currSellOrder: {}
    }
  },
  computed: {
    ...mapGetters(['token'])
  },
  async mounted() {
    this.form.main_id = parseInt(this.$route.query.id)
    if (this.form.main_id) {
      const sellOrderResp = await getSellOrderList({ id: this.form.main_id })
      const sellOrderRows = sellOrderResp.rows || []
      if (sellOrderRows.length > 0) {
        this.currSellOrder = sellOrderRows[0]
        if (this.currSellOrder.status >= this.CONST.SELL_ORDER_STATUS.find(status => status.name === '订单送出').id) {
          this.form.start_longitude = this.currSellOrder.arrived.start_longitude
          this.form.start_latitude = this.currSellOrder.arrived.start_latitude
          this.hasIssued = true
        }
      } else {
        this.hasError = true
        this.errorMsg = '参数错误，获取订单信息失败'
        this.alert(this.errorMsg)
        return
      }
      const config = {
        timestamp: Date.now(),
        nonceStr: 'esap',
        jsurl: window.location.href,
        jsapp: this.CONST.AGENT_MAP[this.$route.path]
      }
      const resp = await wxJsConfig(config)
      if (resp.obj && resp.obj.appId && resp.obj.signature) {
        wx.config({
          beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: resp.obj.appId, // 必填，企业微信的corpID
          timestamp: config.timestamp, // 必填，生成签名的时间戳
          nonceStr: config.nonceStr, // 必填，生成签名的随机串
          signature: resp.obj.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
          jsApiList: ['getLocation', 'openLocation'] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
        })
        wx.ready(() => {
          // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
          if (!this.hasIssued) {
            wx.getLocation({
              type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
              success: (res) => {
                this.form.start_longitude = res.longitude // 经度，浮点数，范围为180 ~ -180
                this.form.start_latitude = res.latitude // 纬度，浮点数，范围为90 ~ -90
                this.canIssued = true
                this.success('获取位置信息成功')
              }
            })
          }
        })
        wx.error(res => {
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
          console.error(res)
          this.hasError = true
          this.errorMsg = '初始化企业微信接口错误'
          this.alert(this.errorMsg)
        })
      } else {
        this.hasError = true
        this.errorMsg = '初始化企业微信接口错误'
        this.alert(this.errorMsg)
      }
    } else {
      this.hasError = true
      this.errorMsg = '参数错误，请您从企业微信端进入'
      this.alert(this.errorMsg)
    }
  },
  methods: {
    openLocation() {
      wx.openLocation({
        longitude: this.form.start_longitude, // 经度，浮点数，范围为180 ~ -180
        latitude: this.form.start_latitude, // 纬度，浮点数，范围为90 ~ -90
        name: this.hasIssued ? '上报位置' : '当前位置', // 位置名
        address: this.hasIssued ? '上报位置' : '当前位置', // 地址详情说明
        scale: 1 // 地图缩放级别,整形值,范围从1~28。默认为16
      })
    },
    handleIssued() {
      this.canIssued = false
      this.confirm('确定标记为【订单送出】状态吗？').then(() => {
        issuedSellOrder(this.form).then(resp => {
          this.success(resp.msg)
          this.hasIssued = true
          this.alert('订单送出成功')
        }).catch(_ => {
          this.canIssued = true
          this.alert('标记订单送出失败，请您稍后再试')
        })
      }).catch(_ => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/delivery/issued.vue